import React, { Fragment } from "react";
import commonUtil from "../../../../../../utils/commonUtil";
import serverClientUtil from "../../../../../../utils/serverClientUtil";


const AddGiftsButton = ({ selectedTheme, lables, selectedTab, isDisable=false }) => {
  const color800 = selectedTheme?.color_800 ?? "#1C1C1C";

  const scrollToAddItem = () => {

    const url = commonUtil.getLabel(
      lables.EventAdminPage,
      `adminpage.regalosregistrados.anadir.href.${serverClientUtil.getBrand()}`
    );

    if(url) {
      window.location.href = url;
    }
  };

  return (
    <Fragment>
      {selectedTab != 'summary' && 
      <div className="row 1">
        <div className="col-xs-12">
          <div className="anadir-regalos-div">
            <button
              className="anadir-regalos-btn"
              onClick={scrollToAddItem}
              style={{ backgroundColor: color800 }}
              disabled={isDisable}
            >
              {commonUtil.getLabel(
                lables.EventAdminPage,
                "adminpage.regalosregistrados.anadir.label"
              )}
            </button>
          </div>
        </div>
      </div>}
    </Fragment>
  );
};

export default AddGiftsButton;
